// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popover-slider-bar .form-container .form-item .form-label[data-v-ae3eadd8]{width:28%!important}.popover-slider-bar .form-container .form-item .form-input-item[data-v-ae3eadd8]{width:72%!important}", ""]);
// Exports
module.exports = exports;
